const parseFromHeToInternPhoneFormat = (phone) => {
    const regx = /^0[0-9]{9}$/
    const isHebrew = regx.test(phone)
    return isHebrew ? phone.replace(/^0/, '+972') : phone
}

export default parseFromHeToInternPhoneFormat
